import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateAddDamping = {
  addDamping: { data: null, loading: false, error: null },
};

export const addDamping = createAsyncThunk('user/addDamping', async (data, { rejectWithValue, fulfillWithValue }) => {
  const token = localStorage?.getItem('token');
  if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
  return await axios
    .post(`${process.env.REACT_APP_SERVER_API}/kaspi-products/damping/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerAddDamping = {
  [addDamping.pending]: (state) => {
    state.addDamping.loading = true;
  },
  [addDamping.fulfilled]: (state, action) => {
    state.addDamping.loading = false;
    state.addDamping.data = action.payload;
    state.addDamping.error = null;
  },
  [addDamping.rejected]: (state, action) => {
    state.addDamping.loading = false;
    state.addDamping.error = action.payload;
  },
};
